import { isNil, set, get } from 'lodash';

type SchemaField = { type: string; };
type AnySchemaType = Record<string, SchemaField>;

// @deprecated - should be removed
export const assignSchemaDefaults = <T extends object, S extends AnySchemaType>(schema: S, obj: T, schemas: Record<string, AnySchemaType> = {}) => {
  const outgoing = { ...obj };
  for (const k in schema) {
    const value = get(outgoing, k);
    const schemaType = schema[k];
    if (isNil(value)) {
      switch (schemaType.type) {
        case 'string': set(outgoing, k, ''); break;
        case 'text': set(outgoing, k, ''); break;
        case 'number': set(outgoing, k, 0); break;
        case 'array': set(outgoing, k, []); break;
        case 'boolean': set(outgoing, k, false); break;
        default:
          if (k in schemas) { set(outgoing, k, assignSchemaDefaults(schemas[k], {}, schemas)); }
          else { set(outgoing, k, undefined); }
          break;
      }
    } else if (schemaType.type in schemas) {
      set(outgoing as any, k, assignSchemaDefaults(schemas[schemaType.type], value as any, schemas));
    }
  }
  return outgoing;
}